import React, { useMemo, useState } from 'react';
import { AlertTriangle, CheckCircle2, Trash2 } from 'lucide-react';
import { useAppStore } from '../../../../app/hooks/useAppStore';
import { detectOrphanedClassrooms, cleanupOrphans } from '../../../../accounts';
import { Button } from '../../../../components/ui/Button';
import { Card } from '../../../../components/ui/Card';
import { ConfirmDialog } from '../../../../components/shared/ConfirmDialog';
export function OrphanStatus() {
  const {
    accounts,
    setAccountsState
  } = useAppStore();
  const [isCleaning, setIsCleaning] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const report = useMemo(() => detectOrphanedClassrooms(accounts), [accounts]);
  const handleCleanup = () => {
    setIsCleaning(true);
    setTimeout(() => {
      const nextState = cleanupOrphans(accounts, report);
      setAccountsState(nextState);
      setIsCleaning(false);
      setShowConfirm(false);
    }, 500);
  };
  if (report.totalIssues === 0) {
    return <Card className="p-8 text-center border-emerald-200 bg-emerald-50/50" data-id="element-6880">
        <div className="flex justify-center mb-4" data-id="element-6881">
          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600" data-id="element-6882">
            <CheckCircle2 className="w-6 h-6" data-id="element-6883" />
          </div>
        </div>
        <h3 className="text-lg font-bold text-emerald-900 mb-2" data-id="element-6884">
          Geen wees-records gevonden
        </h3>
        <p className="text-emerald-700 text-sm" data-id="element-6885">
          De database is gezond. Alle klassen hebben een eigenaar en alle
          gekoppelde co-docenten en leerlingen bestaan.
        </p>
      </Card>;
  }
  return <div className="space-y-6" data-id="element-6886">
      <Card className="p-6 border-amber-200 bg-amber-50/50" data-id="element-6887">
        <div className="flex items-start justify-between" data-id="element-6888">
          <div className="flex items-start gap-4" data-id="element-6889">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 flex-shrink-0 mt-1" data-id="element-6890">
              <AlertTriangle className="w-5 h-5" data-id="element-6891" />
            </div>
            <div data-id="element-6892">
              <h3 className="text-lg font-bold text-amber-900 mb-1" data-id="element-6893">
                {report.totalIssues} wees-records gevonden
              </h3>
              <p className="text-amber-700 text-sm mb-4" data-id="element-6894">
                Er zijn klassen of koppelingen gevonden waarvan het bijbehorende
                account niet meer bestaat. Dit kan gebeuren bij hard-deletes of
                inconsistente migraties.
              </p>
              <ul className="space-y-2 text-sm text-amber-800" data-id="element-6895">
                {report.orphanedClassrooms.length > 0 && <li data-id="element-6896">
                    <span className="font-bold" data-id="element-6897">
                      {report.orphanedClassrooms.length}
                    </span>{' '}
                    klassen zonder eigenaar
                  </li>}
                {report.orphanedCoTeachers.length > 0 && <li data-id="element-6898">
                    <span className="font-bold" data-id="element-6899">
                      {report.orphanedCoTeachers.length}
                    </span>{' '}
                    ontbrekende co-docenten
                  </li>}
                {report.orphanedLearners.length > 0 && <li data-id="element-6900">
                    <span className="font-bold" data-id="element-6901">
                      {report.orphanedLearners.length}
                    </span>{' '}
                    ontbrekende leerlingen in klassen
                  </li>}
              </ul>
            </div>
          </div>
          <Button onClick={() => setShowConfirm(true)} className="bg-amber-600 hover:bg-amber-700 text-white" data-id="element-6902">
            <Trash2 className="w-4 h-4 mr-2" data-id="element-6903" />
            Opschonen
          </Button>
        </div>
      </Card>

      <ConfirmDialog open={showConfirm} title="Wees-records opschonen" message={`Weet je zeker dat je ${report.totalIssues} wees-records wilt verwijderen? Klassen zonder eigenaar worden volledig verwijderd. Ontbrekende co-docenten en leerlingen worden uit hun klassen gehaald.`} confirmLabel={isCleaning ? 'Bezig...' : 'Ja, schoon op'} cancelLabel="Annuleren" variant="danger" onConfirm={handleCleanup} onCancel={() => setShowConfirm(false)} data-id="element-6904" />
    </div>;
}